import {Dom} from 'main.core';
import {EventEmitter} from 'main.core.events';
import CanvasMaster from './canvas-master';
import {CanvasDefault} from "./canvas-default";

export default class CanvasPreview extends CanvasDefault
{
}

